import { VmsService } from './../../services/vms.service';
import { Router } from '@angular/router';
import { Component, NgZone, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { AppStateProvider } from 'src/app/providers/app-state.provider';
import { NgbCalendar, NgbDate, NgbDateAdapter, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { DateService } from 'src/app/services/date.service';

@Component({
  standalone: false,
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit {
  toDate: Date;
  selectedToDate: any;
  tDate: any;
  formattedSelectedToDate: any;
  fromDate: Date;
  fDate: any;
  selectedDate: any;
  formattedSelectedDate: any;
  searchText: string = '';
  companyList: any;
  multiSelectionCompanyName: any = [];
  selectedCompanyName: any;
  selctionlength: number;
  selectedId: any;
  historyList: any=[];
  page: any=1;
  tempHistoryList: any=[];
  pageSize: number=10;
  tempDate: any;
  formattedDate: string;

  constructor(
    private router: Router,
    public datepipe: DatePipe,
    private appStateSrv: AppStateProvider,
    private zone: NgZone,
    private dateAdapter: NgbDateAdapter<string>,
    private ngbCalendar: NgbCalendar,
    private ngbDatepickerConfig: NgbDatepickerConfig,
    private dateSrv: DateService,
    private invSrv: VmsService
  ) {
    ngbDatepickerConfig.minDate = {
      year: 1970, month: 1, day: 1
    };

    ngbDatepickerConfig.outsideDays = 'visible';
  }

  ngOnInit(): void {
    console.log(localStorage.getItem('type'))
    const jsDate = new Date();
    this.selectedDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(new Date().getDate(), new Date().getMonth(), new Date().getFullYear());
    this.selectedToDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(new Date().getDate(), new Date().getMonth(), new Date().getFullYear())
    this.fromDate = new Date(jsDate.toLocaleDateString('en-US'));
    this.toDate = new Date(jsDate.toLocaleDateString('en-US'));
    this.fDate = this.updateDateToCalendar();
    this.tDate = this.updateDateToCalendar();
    this.getCompanyList();
    this.getHistoryList();
  }

  getCompanyList() {
    const data = {
      parkId: localStorage.getItem('parkId'),
      buildingId: [localStorage.getItem('parkId')],
      isActive: true,
    };

    this.invSrv.getCompanyList(data).subscribe((res) => {
      this.companyList = res;
      const allOpt = {
        buildingId: null,
        tenantName: 'All',
      };
      this.companyList.unshift(allOpt);
      console.log(res);
      if (this.selectedId == null && this.companyList.length > 0) {
        this.selectedId = this.companyList[0].buildingId;
        this.selectCompanyName(this.companyList[0]);
      }
    });
  }

  getHistoryList() {
    console.log(this.multiSelectionCompanyName)
    const data = {
      resquestStatus: [true],
      fromDate: this.selectedDate,
      toDate: this.selectedToDate,
      search: this.multiSelectionCompanyName.length>0?this.selectedCompanyName:null,
      pageNo: this.page,
      size: this.pageSize,
      invitationType: (localStorage.getItem('type')=='individual-invite')?'individualInvite':'bulkInvite',
      parkTenantId: localStorage.getItem('parkTenantId'),
      userId: 0,
    };
    this.invSrv.getHistoryDetail(data).subscribe((res) => {
      console.log(res);
      this.historyList=res.list;
      this.tempHistoryList=this.historyList;
      // this.handlePageChange(1);
    });
  }

  selectCompanyName(item) {

    if (item.buildingId !== null)
      if (this.multiSelectionCompanyName.includes(item.buildingId))
        this.multiSelectionCompanyName.splice(
          this.multiSelectionCompanyName.indexOf(item.buildingId),
          1
        );
      else this.multiSelectionCompanyName.push(item.buildingId);
    else this.multiSelectionCompanyName = [];

    let length = this.multiSelectionCompanyName.length - 1;
    this.selctionlength = length;
    this.selectedId = item.buildingId;
    if (item.tenantName != 'All') {
      this.selectedCompanyName = this.companyList.find(
        (x) =>
          x.buildingId ==
          this.multiSelectionCompanyName[
            this.multiSelectionCompanyName.length - 1
          ]
      )?.tenantName;
    } else {
      this.selectedCompanyName = item.tenantName;
    }
    this.getHistoryList();
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  public async updateSelectedDate(date: NgbDate) {
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    const jsDate = new Date(date.year, date.month - 1, date.day);
    this.fromDate = jsDate;
    this.fDate = this.updateDateToCalendar(date);
    this.selectedDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(date.day, date.month - 1, date.year);
    if (this.fromDate && this.toDate) {
      if (this.fromDate <= this.toDate) {
      this.getHistoryList();
      } else {
        this.zone.run(() => {
          this.selectedDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
          this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(new Date().getDate(), new Date().getMonth(), new Date().getFullYear());
        this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(new Date().getDate(), new Date().getMonth(), new Date().getFullYear());
        this.fDate = this.updateDateToCalendar();
        this.tDate = this.updateDateToCalendar();
        });
        this.appStateSrv.showToast(
          'From date should not be greater than to date'
        );
        await delay(2000);
        this.getHistoryList();
      }
    } else {
      this.appStateSrv.showToast('Please select from and to date');
    }
  }

  updateDateToCalendar(date?: NgbDate) {
    const updatedDate =
      date == undefined
        ? this.dateAdapter.toModel(this.ngbCalendar.getToday())!
        : this.dateAdapter.toModel(date)!;
    return updatedDate;
  }

  public async updateSelectedToDate(date: NgbDate) {
    const jsDate = new Date(date.year, date.month - 1, date.day);
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    this.toDate = jsDate;
    this.selectedToDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(date.day, date.month - 1, date.year);
    if (this.fromDate && this.toDate) {
      if (this.fromDate <= this.toDate) {
        this.getHistoryList();
      } else {
        this.selectedDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
        this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(new Date().getDate(), new Date().getMonth(), new Date().getFullYear());
        this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(new Date().getDate(), new Date().getMonth(), new Date().getFullYear());
        this.fDate = this.updateDateToCalendar();
        this.tDate = this.updateDateToCalendar();
        this.appStateSrv.showToast(
          'From date should not be greater than to date'
        );
        await delay(2000);
        this.getHistoryList();
      }
    } else {
      this.appStateSrv.showToast('Please select from and to date');
    }
  }

  handlePageChange(event) {
    console.log(event)
    this.page = event;

    console.log('pagination clicked');
    this.getHistoryList()
    // this.historyList = this.tempHistoryList.slice(
    //   0,
    //   this.tempHistoryList.length < 10
    //     ? this.tempHistoryList.length
    //     : (this.page - 1) * this.pageSize + this.pageSize
    // );
  }

  formatDate(date,type){
    if(date==null) return
    this.tempDate=date.split('T')[0].split('-');
    this.formattedDate=this.dateSrv.convertDateToLocaleString(this.tempDate[2],this.tempDate[1]-1,this.tempDate[0])
    if(type=='date') return this.tempDate[2]
    if(type=='month') return this.formattedDate.split(' ')[1]
    if(type=='format') return this.formattedDate.split(' ')[0]+' '+this.formattedDate.split(' ')[1]+','+this.formattedDate.split(' ')[2]
    if(type=='formatDate') return this.formattedDate
  }


  navigateToDetail(id){
    localStorage.setItem('navigate', '2');
    this.router.navigate(['/vms/detail'],{queryParams:{id:id,type:(localStorage.getItem('type')=='individual-invite')?'individual':'bulk'}});
  }

}
